/** User-facing label for a skipped receipt row. */
export function receiptSkipReasonLabel(reason, itemName) {
  const name = (itemName || '').trim()
  if (reason === 'non-food') return 'Non-food item'
  if (/^item\s+name\s+not\s+found/i.test(name)) return 'Missing product name'
  return 'Unrecognized'
}

export function hasReceiptSkippedItems(unrecognizedItems) {
  return (unrecognizedItems || []).length > 0
}
